export {
	DEFAULT_CONTRIBUTORS_FETCH_LIMIT,
	CONFLUENCE_EDITION,
} from '../src/defaultQueryVariables.js';
